<template>
  <div>
    <!-- Desktop View -->
    <div class="hidden px-12 mx-auto overflow-hidden bg-white lg:px-18 lg:w-486 xl:w-650 lg:grid">
      <h1 class="py-12 font-bold text-28 md:text-34 lg:text-42">
        {{ event.title }}
      </h1>

      <div class="w-full">
        <div class="flex flex-wrap gap-2 py-14 text-orange w-fit">
          <i class="mr-6 fas fa-map-marker-alt"></i>
          <a v-for="(location, index) in event.locations"
            :key="index"
            :href="location.url"
            class="flex location-span hover:underline">

            <h2 class="italic font-semibold lg:mb-12 md:text-18">
              {{ location.name }}
            </h2>
          </a>
        </div>
      </div>
      
      <h3 class="mb-32 italic md:text-18">
        {{ event.date }}
      </h3>
      <div class="leading-6 nova-wysiwyg text-18 md:text-20" v-html="event.longDescription"></div>
    </div>

    <!-- Mobile View -->
    <div class="relative grid lg:col-span-6 lg:hidden">
        <div class="absolute bottom-0 left-0 z-20 px-20">
          <h1 class="py-12 font-bold text-white text-32 text-shadow">
            {{ event.title }}
          </h1>

          <div class="w-full">
            <div class="flex flex-wrap gap-2 text-white py-14 w-fit text-shadow">
              <span><i class="mr-4 fas fa-map-marker-alt"></i></span>
              <a v-for="(location, index) in event.locations"
                :key="index"
                :href="location.url"
                class="flex location-span">

                <h2 class="mb-12 italic font-semibold md:text-18">
                  
                  {{ location.name }}
                </h2>
              </a>
            </div>
          </div>
            
          <h3 class="mb-32 italic text-white md:text-18 text-shadow">
            {{ event.date }}
          </h3>
        </div>
        <div class="absolute z-10 w-full h-346 bg-gradient-to-t from-black/5"></div>
        <img class="object-cover w-full h-346" :src="event.images.background.lg" :alt="event.images.altImage">
    </div>

    <div class="grid px-20 pt-32 mx-auto overflow-hidden bg-white lg:w-650 lg:hidden"
        :class="hidden ? 'h-276 md:h-230 lg:h-370' : 'h-auto'"
        id="exhibit-description">
      <div class="leading-6 nova-wysiwyg text-18 md:text-20" v-html="event.longDescription"></div>
    </div>
    <div v-show="showButton && hidden" class="relative grid w-full text-center lg:hidden read-more mt-100- pt-100"></div>
    <div v-show="showButton" class="left-0 grid w-full mt-40 text-center lg:hidden">
      <button class="grid underline text-orange focus:outline-none lg:hidden" @click="hidden = !hidden">
        {{ hidden ? 'READ MORE' : 'READ LESS' }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheDescriptionBox",

  props: {
    event: {
      required: true,
      type: Object,
    }
  },

  data () {
    return {
      hidden: true,
      rendered: false,
    }
  },

  computed: {
    showButton () {
      if (this.rendered && this.$mq.lg) {
        return this.containerHeight > 370;
      } else if (this.rendered && this.$mq.md) {
        return this.containerHeight > 230;
      } else if (this.rendered) {
        return this.containerHeight > 276;
      }

      return true
    },

    containerHeight () {
      return document.getElementById('exhibit-description').offsetHeight
    }
  },

  updated() {
    this.$nextTick(function () {
      this.rendered = true
    })
  }
}
</script>

<style scoped>
.read-more {
  background-image: linear-gradient(to bottom, transparent, white);
}
.text-shadow {
  text-shadow: 0px 0px 10px #000000;
}

.location-span:not(:last-child):after {
  content: ',';
  margin-right: 4px;
  font-family: sans-serif;
  font-weight: bold;
}
</style>
